import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

export const parseCurrency = (value: string) =>
  Number(parseFloat(value.replace(/[^\d.]/g, ''))?.toFixed(2));

export const formatCurrency = (value: number) => {
  const hasCents = value % 1 !== 0;

  return `$${Intl.NumberFormat('en-AU', {
    minimumFractionDigits: hasCents ? 2 : 0,
  }).format(value)}`;
};

export const isValidCurrency = (value: string): boolean => {
  const currencyRegex =
    /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;
  return currencyRegex.test(value.replace(/[/$,]/, ''));
};

export const abbreviateNumber = (value: number) => {
  const SI = ['', 'K', 'M', 'B', 'T'];
  const tier = Math.min((Math.log10(Math.abs(value)) / 3) | 0, SI.length - 1);
  if (tier === 0) return value;
  const scaled = value / Math.pow(10, tier * 3);
  return Math.floor(scaled * 10) / 10 + SI[tier];
};

export const joinPaths = (...segments: string[]) => {
  return segments.join('/').replace(/\/+/g, '/');
};

export const anchorClickHandler = (e: any) => {
  e.preventDefault();
  const targetLink = (e.target as Element).closest('a');
  return targetLink?.getAttribute('href');
};

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth', // Optional if you want to skip the scrolling animation
    });
  }, [pathname]);

  return null;
};
